export default {
  NAME: "Futura",
  ID: "106",
};
